import type { PersistedStateOptions } from 'pinia-plugin-persistedstate'

/**
 * 状态持久化配置
 * 用于配置不同store的持久化行为
 */

export const persistConfig = {
  /**
   * 基础持久化配置
   */
  baseConfig: {
    // 存储键的前缀
    keyPrefix: 'app_store_',
    // 存储方式：localStorage (默认) | sessionStorage | custom
    storage: localStorage,
    // 是否在开发环境启用持久化
    enabled: import.meta.env.PROD || true,
  },

  /**
   * auth store 持久化配置
   */
  auth: {
    // 使用自定义存储键
    key: 'app_auth',
    // 指定要持久化的状态字段
    paths: ['token', 'userInfo'],
    // 使用sessionStorage存储（可选，根据需求调整）
    // storage: sessionStorage,
    // 自定义序列化函数
    serializer: {
      serialize: (value) => JSON.stringify(value),
      deserialize: (value) => {
        try {
          return JSON.parse(value)
        } catch (e) {
          console.error('Failed to deserialize auth state:', e)
          return null
        }
      }
    },
    // 自定义恢复状态的钩子函数
    beforeRestore: (context) => {
      console.log('Restoring auth state...')
    },
    afterRestore: (context) => {
      console.log('Auth state restored successfully')
    }
  },

  /**
   * 创建持久化配置的工具函数
   * @param name store名称
   * @param config 自定义配置
   * @returns 合并后的持久化配置
   */
  createPersistConfig: <T extends string>(
    name: T,
    config?: Partial<PersistedStateOptions>
  ): PersistedStateOptions => {
    const storeConfig = persistConfig[name as keyof typeof persistConfig] as Partial<PersistedStateOptions> || {}
    
    return {
      ...persistConfig.baseConfig,
      ...storeConfig,
      ...config,
      // 确保key的唯一性
      key: config?.key || storeConfig.key || `${persistConfig.baseConfig.keyPrefix}${name}`,
    }
  }
}

export default persistConfig